export default function({
    settings = {},
    name,
    onChange
}) {

    return [
        {
            type: "InputNumber",
            data: {
                onChange,
                attrs: {
                    placeholder: "Введите время",
                    value: settings[name],
                }
            }
        }
    ]
}